<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="70%" top="5vh">
    <div class="mailTable">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-input
            v-model="searchValue"
            placeholder="供应商名称"
            size="mini"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" size="mini" @click="SearchData"
            >查询</el-button
          ></el-col
        >
      </el-row>
      <el-table
        :data="tableData"
        size="mini"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        :header-row-style="{ height: '40px', 'font-size': '14px' }"
        height="60vh"
        :class="type == 'checkBox' ? 'checkBoxTable' : 'radioTable'"
        @select="handleSelect"
        @row-click="handleRowClick"
        style="margin-top: 10px"
      >
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <!-- <el-table-column v-else type="radio" width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioSelect" :label="scope.$index">{{ "" }} </el-radio>
          </template>
        </el-table-column> -->
        <el-table-column prop="cVenCode" label="供应商编号"></el-table-column>
        <el-table-column prop="cVenName" label="供应商名称"></el-table-column>
        <el-table-column prop="cVenPerson" label="联系人"></el-table-column>
        <el-table-column prop="cVenPhone" label="手机号"></el-table-column>
        <!-- <el-table-column
          prop="EquipmentClassificationName"
          label="设备分类"
        ></el-table-column> -->
      </el-table>
      <el-row style="text-align: right; margin-top: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </el-row>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: { default: '选择供应商', require: false, type: String },
    type: { default: 'checkBox', require: false, type: String },
  },
  data() {
    return {
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      tableData: [],
      dialogVisible: false,
      selectRows: [],
      radioSelect: null,
      searchValue: '',
    }
  },
  methods: {
    handleSelect(selection, row) {
      console.log(selection, row)

      if (this.type == 'checkBox') {
        this.selectRows = selection
        return
      }
      this.$refs.multipleTable.clearSelection()
      this.$refs.multipleTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleRowClick(row, column, event) {
      if (this.type == 'checkBox') {
        this.$refs.multipleTable.toggleRowSelection(row)
        return
      }
      this.$refs.multipleTable.clearSelection()
      this.$refs.multipleTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    SearchData() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    open() {
      this.pagination = {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      }
      this.searchValue = ''
      this.dialogVisible = true
      this.getDataList()
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection()
        this.radioSelect = null
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      if (this.type == 'checkBox') {
        this.selectRows = val
        return
      }
    },
    confirm() {
      console.log(this.selectRows, '')
      if (this.selectRows.length <= 0) {
        return this.$notify.warning('请选择供应商')
      }
      this.$emit('select', [...this.selectRows])
      this.dialogVisible = false
      // if (this.type == "checkBox") {
      //   if (this.selectRows.length <= 0) return this.$notify.warning("请选择供应商");
      //   this.$emit("select", [...this.selectRows]);
      //   this.dialogVisible = false;
      // } else {
      //   if (this.radioSelect === null) return this.$notify.warning("请选择供应商");
      //   this.$emit("select", { ...this.tableData[this.radioSelect] });
      //   this.dialogVisible = false;
      // }
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    getDataList() {
      this.$http
        .post('/Base_BasicData/Base_Supplier/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,

          SortField: 'Id',
          SortType: 'desc',

          Search: {
            Condition: 'cVenName',
            Keyword: this.searchValue,
          },
        })
        .then((res) => {
          if (res.Success) {
            this.tableData = res.Data
            this.pagination.total = res.Total
            console.log(this.tableData)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.mailTable {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  padding-top: 10px;
  box-sizing: border-box;

  .el-table::before {
    z-index: inherit;
  }

  &::-webkit-scrollbar {
    height: 2px;
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条里面小方块 */
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e0e0e0;
  }

  &::-webkit-scrollbar-track {
    /* 滚动条里面轨道 */
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    background: transparent;
  }
}
::v-deep
  .radioTable
  .el-table__header-wrapper
  .el-table-column--selection
  .cell {
  display: none;
}
</style>
